import styled from 'styled-components';
// import AnimatedNumbers from "react-animated-numbers";
import React, { useEffect, useState } from 'react';
// @ts-ignore
import AnimatedNumber from 'react-animated-number';

const Balance = styled.div`
    font-family: 'Poppins';
    font-style: normal;
    font-size: 36px;
    text-align: center;    
    margin-top: 87px;
    display: flex;
    justify-content: center;
    color: #FFFFFF;
    min-height: 71px;
`;


const Ticker = (props: any) => {
    const [balance, setBalance] = useState(props.amount);

    useEffect(() => {
        // change balance when props.amount changes
        setBalance(props.amount);
    }, [props.amount]);

    const formatNumber = (n: any) => {
        return parseFloat(n).toString().replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    }
  
    return (
        <Balance>
            {props.symbol}
            {/* <AnimatedNumbers
                animateToNumber={balance}
                fontStyle={{ fontSize: 36 }}
                
            /> */}
            <AnimatedNumber component="span" value={parseFloat(balance)}
                style={{
                    transition: '0.8s ease-out',
                    fontSize: 36,
                    transitionProperty:
                        'background-color, color, opacity'
                }}
                frameStyle={(perc: any) => (
                    perc === 100 ? {} : {backgroundColor: 'transparent'}
                )}
                duration={1200}
                formatValue={(n: number) => formatNumber(n).toString()}
                stepPrecision={2}
            />
        </Balance>
    );
  
}

export default Ticker;
